import { GameAnalysisStatusEnum } from "libs/apiClient";
import { DiscoverGameAnalysisProvider } from "../../../datagrid-configs/discoverGames/constants";

interface DiscoverGameHomeAwayMappingEligibilityAnalysis {
	provider: string | null;
	status?: string | null;
	analyzedAt?: unknown;
	resync?: boolean | null;
	isInProgress: boolean;
}

interface DiscoverGameHomeAwayMappingEligibilityGame {
	homeTeamStartsOnLeft: boolean | null;
	gameAnalysis: DiscoverGameHomeAwayMappingEligibilityAnalysis[];
}

/**
 * Same row as `GameAnalysisRepository::getGameAnalysisByProvider(..., true)`: newest Sportlogiq
 * analysis with `analyzedAt` set, skipping rejected rows. Game analysis is already ordered by id DESC.
 */
export function getCompletedSportlogiqAnalysis<T extends DiscoverGameHomeAwayMappingEligibilityAnalysis>(
	analyses: T[],
): T | null {
	return (
		analyses.find(
			(analysis) =>
				analysis.provider === DiscoverGameAnalysisProvider.Sportlogiq &&
				analysis.analyzedAt != null &&
				analysis.status !== GameAnalysisStatusEnum.Values.Rejected,
		) ?? null
	);
}

export function canSwapDiscoverGameHomeAwayMapping(gameData: DiscoverGameHomeAwayMappingEligibilityGame): boolean {
	const sportlogiqAnalysis = getCompletedSportlogiqAnalysis(gameData.gameAnalysis);
	const hasPendingSportlogiqResync = sportlogiqAnalysis?.resync === true;
	const hasInProgressAnalysis = gameData.gameAnalysis.some((analysis) => analysis.isInProgress === true);

	return (
		gameData.homeTeamStartsOnLeft !== null &&
		sportlogiqAnalysis !== null &&
		hasInProgressAnalysis === false &&
		hasPendingSportlogiqResync === false
	);
}
